var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'internal')?_c('router-link',{staticClass:"link",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.to,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }